import { render } from "./ChartComponent.vue?vue&type=template&id=3a3246bc&scoped=true"
import script from "./ChartComponent.vue?vue&type=script&lang=js"
export * from "./ChartComponent.vue?vue&type=script&lang=js"

import "./ChartComponent.vue?vue&type=style&index=0&id=3a3246bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a3246bc"]])

export default __exports__